import list from "./list";
import form from "./form";
import detail from "./detail";

export default {

    namespaced: true,

    modules: {
        "list" : list,
        "form" : form,
        "detail" : detail,
    },

}